// src/components/Navbar.js
import React from "react";
import { useAuth } from "../AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { ADMIN_UID, isSoundEnabled, setSoundEnabled } from "../config";
import NotificationBell from "./NotificationBell";
import ThemeToggle from "./ThemeToggle";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = user?.uid === ADMIN_UID;
  const isOnAdmin = location.pathname.startsWith("/admin");
  const [muted, setMuted] = React.useState(!isSoundEnabled());

  const handleLogout = async () => { await logout(); navigate("/login"); };
  const toggleSound = () => { const next = !muted; setMuted(next); setSoundEnabled(!next); };

  return (
    <nav className="navbar">
      <div style={{ display: "flex", alignItems: "center", gap: 12, cursor: "pointer" }}
        onClick={() => navigate(isAdmin ? "/admin" : "/dashboard")}>
        <div className="nav-logo" style={{ background: "linear-gradient(135deg, #4fc3f7, #7c4dff)" }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M2 7l10-5 10 5-10 5L2 7z" fill="rgba(255,255,255,0.9)" />
            <path d="M2 7v10l10 5V12L2 7z" fill="rgba(255,255,255,0.6)" />
            <path d="M22 7v10l-10 5V12l10-5z" fill="rgba(255,255,255,0.75)" />
          </svg>
        </div>
        <span style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 22, color: "#e2e8f0", letterSpacing: 1.5 }}>
          SHIP<span style={{ color: "#4fc3f7" }}>FAST</span>
        </span>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {/* Theme toggle */}
        <ThemeToggle />

        {/* Sound toggle */}
        <button className="btn btn-ghost btn-sm" onClick={toggleSound}
          style={{ padding: "8px 10px", fontSize: 16 }} title={muted ? "Unmute" : "Mute"}>
          {muted ? (
            <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
              <line x1="23" y1="9" x2="17" y2="15" /><line x1="17" y1="9" x2="23" y2="15" />
            </svg>
          ) : (
            <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
              <path d="M19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07" />
            </svg>
          )}
        </button>

        <NotificationBell />

        {/* Profile */}
        <button className="btn btn-ghost btn-sm" onClick={() => navigate("/profile")}
          style={{ padding: "8px 10px" }} title="Profile">
          <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" />
          </svg>
        </button>

        {isAdmin && (
          <>
            {isOnAdmin && location.pathname !== "/admin/customers" && (
              <button onClick={() => navigate("/admin/customers")}
                className="btn btn-ghost btn-sm hide-mobile" style={{ color: "#8b5cf6", borderColor: "rgba(139,92,246,0.3)", background: "rgba(139,92,246,0.08)" }}>
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 00-3-3.87" /><path d="M16 3.13a4 4 0 010 7.75" />
                </svg>
                Customers
              </button>
            )}
            <button onClick={() => navigate(isOnAdmin ? "/dashboard" : "/admin")}
              className="btn btn-ghost btn-sm" style={{ color: "#d4a053", borderColor: "rgba(212,160,83,0.3)", background: "rgba(212,160,83,0.08)" }}>
              <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                {isOnAdmin
                  ? <><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /></>
                  : <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                }
              </svg>
              {isOnAdmin ? "My Orders" : "Admin"}
            </button>
          </>
        )}

        <span className="hide-mobile" style={{ color: "#94a3b8", fontSize: 13, maxWidth: 120, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {user?.displayName || user?.email}
        </span>
        <button onClick={handleLogout} className="btn btn-ghost btn-sm">Sign Out</button>
      </div>
    </nav>
  );
}
